import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-Heart',
  standalone: true,
  templateUrl: '../../assets/Heart.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamHeartIcon {}
